export const FRONTEND_STATE_MOBILE_UI_TOPBAR_SHOW = 'FRONTEND_STATE/MOBILE_UI_TOPBAR_SHOW';
export const FRONTEND_STATE_MOBILE_UI_TOPBAR_HIDE = 'FRONTEND_STATE/MOBILE_UI_TOPBAR_HIDE';
